import BasicButton from "@components/button/BasicButton";
import BackHeader from "@components/header/BackHeader";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import useFilterStepStore from "@store/CategoryFilter/useFilterStepStore";
import { useQuery } from "@tanstack/react-query";
import { useApiRequest } from "@utils/ApiRequest";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";

const FilterItem = styled.button<{ focus: boolean }>(({ theme, focus }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  fontSize: "1.6rem",
  fontWeight: theme.fontWeight.medium,
  color: focus ? theme.color.green : theme.color.black,
  lineHeight: "1.6rem",
  cursor: "pointer",
  padding: "2rem 0",
}));

const FilterWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "1.2rem",
  padding: "2rem",
  backgroundColor: "white",
  position: "relative",
  height: "calc(100vh - 14rem)",
});

const ButtonWrapper = styled.div({
  position: "fixed",
  bottom: "-0.4rem",
  left: "50%",
  transform: "translateX(-50%)",
  width: "90%",
  maxWidth: "56rem",
  padding: "2rem",
  zIndex: 10,
});
const SortFilter = () => {
  const { getProductSort } = useApiRequest();
  const theme = useTheme();
  const { setStep } = useFilterStepStore();
  const [searchParams, setSearchParams] = useSearchParams();
  const lang = window.localStorage.getItem("language");

  const [tempSortCode, setTempSortCode] = useState<string | null>(
    searchParams.get("order_by"),
  );

  const [tempSortName, setTempSortName] = useState<string | null>(
    searchParams.get("sort_name"),
  );

  const handleSortSelect = (sortCode: string, sortName: string) => {
    if (tempSortCode === sortCode) {
      setTempSortCode(null);
      setTempSortName(null);
    } else {
      setTempSortCode(sortCode);
      setTempSortName(sortName);
    }
  };

  const handleApply = () => {
    const newParams = new URLSearchParams(searchParams);
    if (tempSortCode && tempSortName) {
      newParams.set("order_by", tempSortCode);
      newParams.set("sort_name", tempSortName);
    } else {
      // 선택된 값이 없으면 파라미터 삭제
      newParams.delete("order_by");
      newParams.delete("sort_name");
    }
    setSearchParams(newParams);
    setStep(0);
  };

  const { data: productSort } = useQuery({
    queryKey: ["getProductList"],
    queryFn: () => getProductSort(),
  });

  return (
    <>
      <BackHeader title="정렬" onClick={() => setStep(1)} />

      <FilterWrapper>
        {productSort?.map((item: any, index: number) => (
          <FilterItem
            key={index}
            focus={item.code === tempSortCode}
            onClick={() =>
              handleSortSelect(
                item.code,
                lang === "en" ? item.name_en : item.name_ko,
              )
            }>
            <span>{lang === "en" ? item.name_en : item.name_ko}</span>

            {item.code === tempSortCode ? (
              <Image src={theme.image.check_green.default} />
            ) : (
              <Image src={theme.image.check_gray.default} />
            )}
          </FilterItem>
        ))}

        <ButtonWrapper>
          <BasicButton
            title="적용"
            width="100%"
            height="5.2rem"
            onClick={handleApply}
          />
        </ButtonWrapper>
      </FilterWrapper>
    </>
  );
};

export default SortFilter;
